import { loginRequest } from "../authConfig";
import { useMsal} from "@azure/msal-react";
import { 
    Button, 
    Card 
} from "react-bootstrap";

export const WelcomePage = (props) => {

    const { instance } = useMsal();
        
    const handleLogin = () => {
        console.log(loginRequest);
         instance.loginRedirect(loginRequest).catch(e => {
            console.log(e);
        });
    }
    return (
        <>
            <div className="container">
                <div className="mx-auto pb-4 text-center">
                    <img src="/idb-invest-logo.svg" style={{ height: '3rem' }} />
                </div>
                <Card style={{ width: '35rem', margin: '0 auto' }}>
                    <Card.Img style={{ maxHeight: '15rem' }} variant="top" src="climated-related.jpg" />
                    <Card.Body>
                        <Card.Title className="h1">Agriadapt</Card.Title>
                        <Card.Text className="text-justify">
                            A tool to analyze physical climate-related risks for agribusiness transactions to provide information during due diligence to both the transaction team and the client. The objective is to understand the transactions climate risk and vulnerability and to be able to prioritize, discuss and offer relevant adaptation solutions to the client.
                            <br />
                        </Card.Text>
                    </Card.Body>
                    <Card.Footer className="text-center">
                        <Button variant="outline-success" onClick={() => handleLogin()}>Login</Button>
                    </Card.Footer>
                </Card>
            </div>
        </>
    );
}